import { html } from "../../base/_utils";
import staffModal from "./_staff-modal";

export default function staffCard(member, path) {
    return html`
        <div class="card staff-card h-100 border-0 bg-gray-light text-center fade-in">
            <div class="card-img-top">
                <a class="staff-modal-trigger" href="#" data-bs-toggle="modal" data-bs-target="#${member.id}-modal">
                    <div class="staff-card-overlay d-flex flex-column justify-content-center align-items-center">
                        <img class="img-fluid staff-hover-logo w-25" src="${path}assets/media/global/logos/northern-n.svg" loading="lazy" alt="Northern Foundation Logo" />
                        <p class="h4 text-body mb-0 mt-2">View Bio</p>
                    </div>
                </a>
                <img class="img-fluid staff-image w-100" src="${path}${member.image}" loading="lazy" alt="${member.name} headshot" />
            </div>
            <div class="card-body">
                <p class="h3 staff-name">${member.name}</p>
                <p class="staff-title fw-bold fs-5">${member.title}</p>
            </div>
        </div>
        ${staffModal(member, path)}
    `;
}
